// @ts-nocheck

import { selectBetBoostedOddCardMode } from '../../selectors/bet.selector';
import { MatchEntity } from '../../states/entities/matches';
import { OutcomeEntity } from '../../states/entities/outcomes';
import { CardModes } from '../../types/common';
import { VoidReasons } from '../../types/history';
import { StatusFilters } from '../../types/history';
import { SportIds } from '../../types/sports';

const getMatchScore = (match) => {
  if (match?.isOutright) return;
  if (
    [
      SportIds.TENNIS,
      SportIds.PADEL,
      SportIds.TABLE_TENNIS,
      SportIds.VOLLEYBALL,
      SportIds.BEACH_VOLLEY,
      SportIds.BADMINTON,
    ].indexOf(match?.sportId) !== -1
  ) {
    return match?.setScores?.replace(/ - /g, ' ').replace(/:/g, '-');
  }

  return match?.score?.replace(/:/g, '-');
};

const legacyHistoryItemOutcomeCardSelector = (
  state,
  { betslipVoidReason, statusFilter, outcomeInfo }: HistoryItemOutcomeCardContainerProps,
) => {
  const { outcome, bet, match, isLive, status, tournament, category } = outcomeInfo;

  if (statusFilter && statusFilter !== StatusFilters.ALL && status !== statusFilter) {
    return null;
  }

  const isEnded = MatchEntity.isEnded(match);
  const matchScore = getMatchScore(match);
  const isSpecialOdds = category?.sportId === SportIds.SPECIAL_ODDS;
  const to = isSpecialOdds ? `/sports/100000` : match?.matchId ? `/match/${match.matchId}` : null;
  const isSettled = OutcomeEntity.isSettled(status);
  const isOutright = match?.isOutright;
  const { sportId } = match;

  const getFlagId = () => {
    if (sportId === SportIds.ESPORT) {
      return category?.flag ?? tournament?.flag;
    }

    return tournament?.flag ?? category?.flag;
  };

  const flagId = getFlagId();
  const betId = outcome?.betId;

  const cardMode = betId ? selectBetBoostedOddCardMode(state, { betId }) : CardModes.NORMAL;

  const deadHeat = outcome?.deadHeat;
  const betVoidReason = bet?.voidReason;
  const voidReason = deadHeat
    ? VoidReasons.DEAD_HEAT_FACTOR
    : betVoidReason ?? betslipVoidReason ?? outcome?.voidReason;

  return {
    outcome,
    startDate: match?.matchStart,
    sportId: category?.sportId,
    categoryId: category?.categoryId,
    flagId,
    isLive,
    isEnded,
    cardMode,
    status,
    title: match?.title,
    betResult: bet?.result,
    to,
    matchScore,
    isOutright,
    matchId: match?.matchId,
    isMyMatch: outcome?.subOutcomes,
    voidReason,
    isSettled,
  };
};

export default legacyHistoryItemOutcomeCardSelector;
